<mat-form-field class="full-bredde">
    <mat-label>{{ 'Avtaler' | translate }}</mat-label>
    <mat-chip-grid #chipGrid [attr.aria-label]="'Valgte avtaler' | translate">
        @for (avtale of valgteAvtaler(); track avtale.id) {
            <mat-chip-row (removed)="fjern(avtale)" data-testid="valgt-avtale">
                {{ avtale.navn }}
                @if (statustekst(avtale); as status) {
                    <span class="status">({{ status | translate }})</span>
                }
                <button matChipRemove [attr.aria-label]="'Fjern {avtale}' | translate: {avtale: avtale.navn}" data-testid="fjern-avtale-knapp">
                    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
                </button>
            </mat-chip-row>
        }
        <input #soekefelt
               [placeholder]="'Søk etter avtale...' | translate"
               [formControl]="soek"
               [matChipInputFor]="chipGrid"
               [matAutocomplete]="avtaleforslag"
               data-testid="soek-avtale-felt">
    </mat-chip-grid>
    <mat-autocomplete #avtaleforslag="matAutocomplete" (optionSelected)="leggTil($event)">
        @for (avtale of forslag(); track avtale.id) {
            <mat-option [value]="avtale" data-testid="avtaleforslag">
                {{ avtale.navn }}
                @if (statustekst(avtale); as status) {
                    <span class="status">({{ status | translate }})</span>
                }
            </mat-option>
        }
    </mat-autocomplete>
</mat-form-field>
